export class Alert {
  type: AlertType;
  message: string;

  constructor(type: AlertType, message: string) {
    this.type = type;
    this.message = message;
  }
}

export enum AlertType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHT = 'light',
  DARK = 'dark'
}
